import React, { FC } from 'react';
import { MyRegisterShipmentContainer } from '../../components/base/grid';
import MyRegisterShipment from '../../components/myPost/myRegisterShipment';
import pageWrapper from '../../hoc/pageWrapper';
import IPageViewModel from '../../interfaces/umbracoNodes/pageViewModel';

interface Props {
	page: IPageViewModel;
}

const MyShipmentsRegisterShipment: FC<Props> = ({ page }) => {
	return (
		<MyRegisterShipmentContainer>
			<MyRegisterShipment page={page} />
		</MyRegisterShipmentContainer>
	);
};

export default pageWrapper(MyShipmentsRegisterShipment);
